import React, { useState } from "react";

const galleryItems = [
  {
    label: "Body Massage",
    category: "massage",
    image:
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    big: true,
  },
  {
    label: "Hot Stone Therapy",
    category: "relaxing",
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    big: false,
  },
  {
    label: "Aroma Bath",
    category: "relaxing",
    image:
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    big: false,
  },
  {
    label: "Facial Care",
    category: "skin",
    image:
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    big: false,
  },
  {
    label: "Body Waxing",
    category: "waxing",
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    big: false,
  },
  {
    label: "Relaxing Pool",
    category: "relaxing",
    image:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80",
    big: false,
  },
];

const galleryResponsiveStyles = `
  *, *::before, *::after { box-sizing: border-box; }

  .gallery-section { overflow-x: hidden; }

  .gallery-tabs {
    flex-wrap: wrap;
    justify-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (max-width: 768px) {
    .gallery-grid {
      grid-template-columns: 1fr 1fr !important;
      padding: 0 1rem;
    }
    .gallery-item {
      height: 180px !important;
    }
  }

  @media (max-width: 480px) {
    .gallery-grid {
      grid-template-columns: 1fr !important;
      padding: 0 1rem;
    }
    .gallery-item {
      height: 220px !important;
    }
  }
`;

function Gallery() {
  const [active, setActive] = useState("All");
  const tabs = ["All", "Massage", "Relaxing", "Waxing", "Skin"];

  const getCategoryFilter = (category) => {
    if (active === "All") return true;
    if (active === "Massage") return category === "massage";
    if (active === "Relaxing") return category === "relaxing";
    if (active === "Waxing") return category === "waxing";
    if (active === "Skin") return category === "skin";
    return true;
  };

  const filteredItems = galleryItems.filter((item) =>
    getCategoryFilter(item.category)
  );

  return (
    <section className="gallery-section" id="gallery">
      <style>{galleryResponsiveStyles}</style>
      <div
        style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
      >
        <div
          className="section-label reveal"
          style={{ justifyContent: "center", marginBottom: "8px" }}
        >
          Our Gallery
        </div>
        <h2 className="section-title reveal" style={{ marginBottom: 0 }}>
          Latest <em>Projects Gallery</em>
        </h2>
      </div>
      <div className="gallery-tabs">
        {tabs.map((t) => (
          <button
            key={t}
            className={`gallery-tab ${active === t ? "active" : ""}`}
            onClick={() => setActive(t)}
          >
            {t}
          </button>
        ))}
      </div>
      <div className="gallery-grid reveal">
        {filteredItems.map((g, i) => (
          <div
            className="gallery-item"
            key={i}
            style={{ height: g.big ? "480px" : "230px" }}
          >
            <img
              src={g.image}
              alt={g.label}
              className="gallery-img"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
            <div className="gallery-overlay">
              <div className="gallery-caption">{g.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
